// react
import { List, Map } from "immutable";
import moment from "moment";

const initialState = Map({
	cycles: Map(),
});

export default function requests(state = initialState, action) {
	switch (action.type) {
		case "REVIEWCYCLE:GETFORMS@SUCCESS": {
			const { reviewCycleID } = action.request.props;

			// convert dates to moments
			const basicForms = action.response.get("forms", List()).withMutations((mutable) => {
				mutable.forEach((form, ii) => {
					const lastStartDate = form.get("lastStartDate");
					mutable.setIn([ii, "lastStartDate"], moment(lastStartDate));
				});
			});

			const externalForms = action.response.get("externalForms", List()).withMutations((mutable) => {
				mutable.forEach((form, ii) => {
					const lastStartDate = form.get("lastStartDate");
					mutable.setIn([ii, "lastStartDate"], moment(lastStartDate));
				});
			});

			const easyAddForms = action.response.get("easyAddForms", List());

			// update store
			return state.withMutations((mutable) => {
				mutable.setIn(["cycles", reviewCycleID, "basicForms"], basicForms);
				mutable.setIn(["cycles", reviewCycleID, "externalForms"], externalForms);
				mutable.setIn(["cycles", reviewCycleID, "easyAddForms"], easyAddForms);
			});
		}
		case "REVIEWCYCLE:GETDETAILS@SUCCESS": {
			const { reviewCycleID } = action.request.props;
			// update store
			return state.withMutations((mutable) => {
				mutable.setIn(["cycles", reviewCycleID, "cycleName"], action.response.get("cycle_name", ""));
				mutable.setIn(["cycles", reviewCycleID, "template", "name"], action.response.get("template_name", ""));
				mutable.setIn(["cycles", reviewCycleID, "template", "id"], action.response.get("template_id", ""));
				mutable.setIn(["cycles", reviewCycleID, "adminsOnly"], action.response.get("admins_only", ""));
				mutable.setIn(["cycles", reviewCycleID, "startDate"], action.response.get("start_date", ""));
				mutable.setIn(["cycles", reviewCycleID, "started"], action.response.get("started", ""));
				mutable.setIn(["cycles", reviewCycleID, "group", "name"], action.response.getIn(["group", "name"], ""));
				mutable.setIn(["cycles", reviewCycleID, "group", "id"], action.response.getIn(["group", "id"], ""));
			});
		}

		case "REVIEWCYCLE:GETMETA@SUCCESS": {
			const { reviewCycleID } = action.request.props;
			// update store
			return state.withMutations((mutable) => {
				mutable.setIn(["cycles", reviewCycleID, "adminsOnly"], action.response.get("admins_only", ""));
				mutable.setIn(["cycles", reviewCycleID, "startDate"], action.response.get("start_date", ""));
				mutable.setIn(["cycles", reviewCycleID, "started"], action.response.get("started", ""));
			});
		}

		default:
			return state;
	}
}
